import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from "../../routes/Routes.js";
import "./Home.css";
function Homepage({ bgColor, sidebarColor,cardColor }) {

  return (
    <div className="main-div"  >
      <div className='content'>
        <Suspense fallback="..Loading">
          <Routes>
            {routes.map((route, idx) => {
              return (
                route.element && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={<route.element sidebarColor={sidebarColor} cardColor={cardColor}/>}
                  />
                )
              )
            })}
            <Route path="/" element={<Navigate to="dashboard" replace />} />
          </Routes>
        </Suspense>
      </div>
    </div>
  )
}

export default Homepage;
